
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { setBreadcrumbItems } from "../../store/actions";
import { connect } from "react-redux";
import { getClientBranchListReq } from "../../service/branchService";
import * as XLSX from "xlsx";

import {
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";

import { Chip } from "@mui/material";
import StyledButton from "../../components/Common/StyledButton";
import BudgetModal from "../../components/CustomComponents/BudgetModal";
import useAuth from "../../hooks/useAuth";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";




const Branches = (props) => {
    const { auth } = useAuth();
    const permissions = auth?.permissions?.find(permission => permission.module === "branches")?.operations || [];
    const associatedBranches = auth?.associatedBranches || [];
    const breadcrumbItems = [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Branches", link: "#" },
    ];
    const [branchList, setBranchList] = useState([]);
    const [clientId, setClientId] = useState(null);
    const [openBudgetModal, setOpenBudgetModal] = useState({
        status: false,
        values: {},
        branchId: null,
        editId: null,
    });

    const getBranchData = useCallback(async () => {
        const response = await getClientBranchListReq();
        if (response) {
            const { branches, clientId } = response.payload;
            setClientId(clientId);
            setBranchList(branches);
        }
    }, []);
    
    useEffect(() => {
        props.setBreadcrumbItems("Branches", breadcrumbItems);
        getBranchData()
    }, []);

    const getAddressValue = (branch) => {
        if(!branch?.address) return '';
        return <>
          {branch?.address.addressLine1},<br />
          {branch?.address.addressLine2 || ''},<br />
          {branch?.address.state}&nbsp;{branch?.address.city}&nbsp;-&nbsp;{branch?.address.pincode}.
        </>;
    };

    const handleBudgetEdit = (branchId, budget) => {
        setOpenBudgetModal({
            status: true,
            values: {
                fieldType: budget.period, 
                fieldValue: budget.amount,
                fiscalYear: parseInt(budget.fiscalYear, 10),
            },
            branchId: branchId,
            editId: budget._id,
        });
    };

    const updateBudgetList = (branchId, budget, isDelete) => {
        setBranchList(prev => {
            return prev.map(branch => {
                if (branchId === branch._id) {
                    let budgetList = branch.budgets;
                    if (isDelete) {
                        budgetList = budgetList.filter(b => b._id !== budget._id);
                    } else {
                        const index = budgetList.findIndex(b => b._id === budget._id);
                        if (index !== -1) {
                            budgetList[index] = budget;
                        } else {
                            budgetList = [...budgetList, budget];
                        }
                    }
                    return {
                        ...branch,
                        budgets: budgetList,
                    }
                }
                return branch;
            });
        });
    };

    const getBudgetList = (budgetList, branchId) => {
        if(budgetList.length === 0) return '';
        return (<table className="table table-bordered align-middle mt-3">
        <thead>
          <tr>
            <th style={{ width: "30%" }}>Fiscal Year</th>
            <th style={{ width: "30%" }}>Type</th>
            <th style={{ width: "50%" }}>Amount(₹)</th>
            <th style={{ width: "20%" }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {budgetList?.map((budget, index) => (
            <tr key={index}>
              <td>{`${budget.fiscalYear}-${parseInt(budget.fiscalYear, 10) + 1}`}</td>
              <td>{budget.period.toUpperCase()}</td>
              <td>{budget.amount}/-</td>
              <td>
                <StyledButton
                  color="primary"
                  size="sm"
                  onClick={() => handleBudgetEdit(branchId, budget)}
                  disabled={!permissions.includes("update") || !associatedBranches.includes(branchId)}
                >
                  Edit
                </StyledButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table>);
    };

    if (branchList?.length === 0) {
        return (
            <h5>No branches found.</h5>
        )
    }
                    
    return (
        <Row className="equal-height-cards">
            {branchList.map((branch, index) => {
                return (
                    <Col key={`${branch.name}-${index}`} xl="6" className="mt-4">
                    <Card>
                        <CardBody style={{paddingBottom: '0px'}}>
                            <Row className="align-items-center">
                                <Col>
                                    <h3 className="card-title capitalize">
                                    {branch?.name}
                                    <span>
                                    {" "}
                                    {branch.isPrimary ? (
                                        <Chip className="mx-2" size="sm" label="Primary" />
                                    ) : null}
                                    </span>
                                    </h3>
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col xs="6">
                                    <p>Associated Warehouse:</p>
                                </Col>
                                <Col xs="6">
                                    <div className="d-flex flex-wrap">
                                        <Chip label={branch?.associatedWarehouse.code} className="mr-2" />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col xs="6">
                                    <p>Address:</p>
                                </Col>
                                <Col xs="6">
                                    {getAddressValue(branch)}
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col xs="6">
                                    <p>Code:</p>
                                </Col>
                                <Col xs="6">
                                    {branch.code}
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col xs="6">
                                    <p>Contact:</p>
                                </Col>
                                <Col xs="6">
                                    <p>{branch?.contact}</p>
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                {getBudgetList(branch.budgets, branch._id)}
                            </Row>
                            <Row className="mt-1">
                                <Col>
                                <StyledButton
                                    color={"primary"}
                                    className={"w-md mx-2"}
                                    onClick={() => setOpenBudgetModal({
                                        status: true,
                                        branchId: branch._id,
                                    })}
                                    disabled={!permissions.includes("create") || !associatedBranches.includes(branch._id)}
                                >
                                    Add Budget
                                </StyledButton>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    </Col>
                )
            })}
            <BudgetModal
                  openModal={openBudgetModal.status}
                  setOpenModal={(status) => setOpenBudgetModal({ status })}
                  values={openBudgetModal.values}
                  editId={openBudgetModal.editId}
                  clientId={clientId}
                  branchId={openBudgetModal.branchId}
                  updateBudgetList={updateBudgetList}
                  notify={() => {}}
                  permissions={permissions}
                  associatedBranches={associatedBranches}
                />
        </Row>
    )
}

export default connect(null, { setBreadcrumbItems })(Branches);
